/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import {
    bool,
    object,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Check from '@material-ui/icons/Check';

const styles = (theme) => ({
    passportDetailsContainer: {
        display: 'flex',
        width: '100%',
        height: 'auto',
        padding: '0 0 15px',
        background: theme?.palette?.colorNeutral20,
    },
    passportDetails: {
        paddingTop: '15px',
        width: '100%',
    },
    passportDetailItem: {
        padding: '5px 6%',
        minHeight: '85px',
        [theme.breakpoints.down('1024px')]: {
            minHeight: '100px',
        },
        [theme.breakpoints.down('600')]: {
            minHeight: '115px',
        },
    },
    passportDetailItemIcon: {
        color: theme?.palette?.primaryButton,
        verticalAlign: 'top',
        display: 'inline-block',
        [theme.breakpoints.down('600')]: {
            width: '20px',
        },
    },
    passportDetailItemText: {
        padding: '4px 0 0 5px',
        color: theme?.palette?.colorNeutral70,
        display: 'inline-block',
        width: '76%',
        fontSize: '15px',
        [theme.breakpoints.down('600')]: {
            width: '80%',
            fontSize: '14px',
        },
    },
    passportDetailTAC: {
        gridColumnStart: '1',
        gridColumnEnd: '3',
        paddingTop: '10px',
        textAlign: 'center',
    },
    passportDetailTACLink: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        textDecoration: 'underline',
        fontSize: '16px',
    },
    passportWrapper: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        padding: '0',
        background: '#FAFAFA',
        borderTop: '1px solid #E9E9E9',
        margin: '0 auto',
        '& $passportDetails': {
            width: '100%',
            margin: '12px 0px',
            padding: '0px',
        },
        '& $passportDetailItem': {
            padding: '16px 16px 0px',
            minHeight: '0px',
            display: 'flex',
            alignItems: 'center',
        },
        '& $passportDetailItemIcon': {
            width: '24px',
            height: '24px',
        },
        '& $passportDetailItemText': {
            width: '95%',
            fontSize: '14px',
            lineHeight: '20px',
            color: '#2f2f2f',
            padding: '0px 0px 0px 16px',
        },
        '& $passportDetailTACLink': {
            fontSize: '14px',
            lineHeight: '20px',
            marginTop: '10px',
            color: '#2F2F2F',
        },
        [theme.breakpoints.up('600')]: {
            marginTop: '20px',
            '& $passportDetails': {
                margin: '14px 0px',
            },
            '& $passportDetailItem': {
                padding: '16px 0px 0px 57px',
                maxWidth: '414px',
                display: 'flex',
                alignItems: 'center',
            },
            '& $passportDetailTAC': {
                paddingTop: '20px',
            },
        },
    },
});

const defaultCopies = [
    { copy: 'Free Standard Shipping on Eligible Items' },
    { copy: 'No Service Charge on Eligible Items when you order 2-Business Days in advance' },
    { copy: 'Reduce Expedited Shipping/Service Fees' },
    { copy: 'No Promo Codes Needed' },
    { copy: 'Automatically renews annually for $29.99' },
];
const variantCopy = {
    copy: 'Minimum cart merchandise value of $25 before taxes and after discounts required.',
    _metadata: { uid: 'new_uid_1' },
};
const PassportBenefitsInfo = ({
    classes, passportData, isPdpRedesignEnabled, passportThresholdVariant, isPlaRedesignEnabled,
}) => {
    const enableCMSCopies = passportData?.default_passport_messages?.enable_pdp_offer_copies;
    const pdpOfferCopies = passportData?.default_passport_messages?.pdp_offer_copies;
    const cmsCopies = passportThresholdVariant && enableCMSCopies ? [variantCopy, ...pdpOfferCopies] : (passportData?.default_passport_messages?.pdp_offer_copies || []);
    const copies = (enableCMSCopies && cmsCopies?.length > 0) ? cmsCopies : defaultCopies;
    // Calculating the lengths of the two arrays
    const copiesLength = Math.ceil(copies.length / 2);

    // Creating the two sets of copy
    const firstCopySet = copies.slice(0, copiesLength); // first column copies
    const secondCopySet = copies.slice(copiesLength);   // second column copies
    return (
        <div className={`${classes.passportDetailsContainer} ${isPdpRedesignEnabled ? classes.passportWrapper : ''}`}>
            <Grid container className={classes.passportDetails}>
                <Grid item xs={isPdpRedesignEnabled ? 12 : 6}>
                    {firstCopySet.map(({ copy }) => (
                        <div className={classes.passportDetailItem}>
                            <Check className={classes.passportDetailItemIcon} />
                            <div className={classes.passportDetailItemText}>{copy}</div>
                        </div>
                    ))}
                </Grid>
                <Grid item xs={isPdpRedesignEnabled ? 12 : 6}>
                    {secondCopySet.map(({ copy }) => (
                        <div className={classes.passportDetailItem}>
                            <Check className={classes.passportDetailItemIcon} />
                            <div className={classes.passportDetailItemText}>{copy}</div>
                        </div>
                    ))}
                </Grid>
                <Grid item xs={12} className={classes.passportDetailTAC}>
                    <Link
                        className={classes.passportDetailTACLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        to="/passport-terms-and-conditions"
                    >
                        *Terms and Conditions
                    </Link>
                </Grid>
            </Grid>
        </div>
    );
};

PassportBenefitsInfo.propTypes = {
    classes: object.isRequired,
    passportData: object.isRequired,
    isPdpRedesignEnabled: bool,
    passportThresholdVariant: bool,
    isPlaRedesignEnabled: bool,
};
PassportBenefitsInfo.defaultProps = {
    isPdpRedesignEnabled: false,
    passportThresholdVariant: false,
    isPlaRedesignEnabled: false,
};
export default withStyles(styles)(PassportBenefitsInfo);
